// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3vUqZ","title":"Images45_title__D3sUd","images":"Images45_images__vQ5Kd"};